import { ChangeDetectionStrategy, Component, HostBinding, Input, computed, inject } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ShowInEpcotDirective } from '@frontend/sports/common/core/feature/show-in-epcot';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { DynamicIconComponent } from '../common/dynamic-icon-loader.component';
import { EpcotNotificationComponent } from '../common/epcotNotifications/notification.component';

@Component({
    selector: 'ms-empty-media',
    templateUrl: './empty-media.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ShowInEpcotDirective, IconCustomComponent, DynamicIconComponent, EpcotNotificationComponent],
})
export class EmptyMediaComponent {
    sitecore = inject(Sitecore);

    @Input() isEventSelected: boolean;
    @Input() isEventLive: boolean;
    @Input() emptyList: boolean;
    @Input() isExpanded: boolean;
    @HostBinding('class') className = 'empty-media';

    message = computed(() => {
        if (this.isEventSelected) {
            return this.isEventLive ? this.sitecore.media.NoLiveStreamingForEvent : this.sitecore.media.NoLiveStreamingForEventPrematch;
        } else {
            return (this.emptyList ? this.sitecore.media.SelectAnimationFromLiveEvents : this.sitecore.media.SelectMediaFromList)
                .replace('{{videoIcon}}', '<span class="icon-container"><vn-icon name="sports-video" size="16" /></span>')
                .replace('{{animationIcon}}', '<span class="icon-container"><vn-icon name="sports-4-match" size="16" /></span>');
        }
    });
}
